import { produce } from 'immer'
import {
  GET_BUILDINGS_LIST,
  GET_GEOJSON_DATA,
  GET_UNITS_BY_BUILDING,
  GET_UNITS_EXCLUDING_BUILDING,
  GET_UNITS_LIST,
  SET_COLOR_MODE,
  SET_FEATURE,
  SET_FILTERS,
  SET_GEOMETRY_DATA,
  SET_PAGE,
  SET_UNIT_DATA,
  SET_UNIT_TYPE_SCREEN,
  SET_UNIT_WITH_DETAILS,
  SET_VIEW_TYPE,
  TOGGLE_LOADING_STATUS
} from '../actions/viewerActions'

const initialState = {
  geometryData: {},
  geoJson: {},
  unit: {},
  units: [],
  unitsByBuilding: [],
  unitsExcludingBuilding: [],
  buildings: [],
  feature: {},
  unitDetails: {},
  filters: {
    max: 9,
    page: 1
  },
  max: 9,
  page: 1,
  totalPages: 1,
  colorMode: 'light',
  loading: false,
  viewType: 'grid',
  unitTypeScreen: 'split'
}

const viewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_LOADING_STATUS: {
      return produce(state, (draft) => {
        draft.loading = action.status
      })
    }
    case SET_GEOMETRY_DATA: {
      return produce(state, (draft) => {
        draft.geometryData = action.payload
      })
    }
    case SET_VIEW_TYPE: {
      return produce(state, (draft) => {
        draft.viewType = action.payload
      })
    }
    case SET_UNIT_TYPE_SCREEN: {
      return produce(state, (draft) => {
        draft.unitTypeScreen = action.payload
      })
    }
    case GET_GEOJSON_DATA: {
      return produce(state, (draft) => {
        draft.geoJson = action.payload
      })
    }
    case SET_UNIT_DATA: {
      return produce(state, (draft) => {
        draft.unit = action.payload
      })
    }
    case SET_FEATURE: {
      return produce(state, (draft) => {
        draft.feature = action.payload
      })
    }
    case SET_COLOR_MODE: {
      return produce(state, (draft) => {
        draft.colorMode = action.mode
      })
    }
    case SET_PAGE: {
      return produce(state, (draft) => {
        draft.page = action.payload
      })
    }
    case SET_FILTERS: {
      return produce(state, (draft) => {
        draft.filters = action.payload
      })
    }
    case SET_UNIT_WITH_DETAILS: {
      return produce(state, (draft) => {
        draft.unitDetails = action.payload
      })
    }
    case GET_UNITS_LIST: {
      return produce(state, (draft) => {
        draft.units = action.payload.items || []
        draft.totalPages = action.payload.totalPages
      })
    }
    case GET_UNITS_BY_BUILDING: {
      return produce(state, (draft) => {
        draft.unitsByBuilding = action.payload.items || []
        draft.totalPages = action.payload.totalPages
      })
    }
    case GET_UNITS_EXCLUDING_BUILDING: {
      return produce(state, (draft) => {
        draft.unitsExcludingBuilding = action.payload.items || []
      })
    }
    case GET_BUILDINGS_LIST: {
      return produce(state, (draft) => {
        draft.buildings = action.payload.items || []
      })
    }
    default: {
      return state
    }
  }
}

export default viewerReducer
